// extracted by mini-css-extract-plugin
export default {"container":"container-Fkjrm","headingWrapper":"headingWrapper-t7UA3","heading":"heading-DDoWD","icon":"icon-r_958"};